import { connect } from 'react-redux'
import Settings from './Settings'
import { listenForPoll, update } from '../../redux/actions/poll'

const mapStateToProps = ({ polls }, { params }) => ({
	poll: polls[params.pollId],
})

const mapDispatchToProps = (dispatch, { params }) => ({
	load() {
		dispatch(listenForPoll(params.pollId))
	},
	update(values) {
		dispatch(update(params.pollId, values))
	},
})

const Container = connect(
  mapStateToProps,
  mapDispatchToProps
)(Settings)

export default Container



// WEBPACK FOOTER //
// ./src/components/settings/Container.jsx